import { Injectable } from "@angular/core";
import { catchError, map, Observable, tap } from "rxjs";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";


@Injectable({ providedIn: 'root' })
export class AuthService {
  private token: string | null = localStorage.getItem('access_token');
  private refreshTokenValue: string | null = localStorage.getItem('refresh_token');

  getAccessToken(): string | null {
    return this.token;
  }

  refreshToken(): Observable<string> {
    return this.http.post<{ access_token: string }>(
      `${environment.API_BASE}/api/refresh_token/${this.refreshTokenValue}`,
      { refreshToken: this.refreshTokenValue }, { observe: 'response' }
    ).pipe(
      tap((response) => {
        if (response.status === 401 || response.status === 405) {
          console.log("response.status == ", response.status);
          this.logout();
          setTimeout(() => {
            window.location.reload();
          }, 0);
        } else {
          this.token = response.body?.access_token ?? null;
          localStorage.setItem('access_token', this.token ?? '');
        }
      }),
      map(response => response.body?.access_token || ''),
      // catchError((error) => )
    );
  }

  logout() {
    this.token = null;
    localStorage.clear();
  }

  constructor(private http: HttpClient) { }
}